var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thousand props-group"},[_c('el-form-item',{attrs:{"label":"使用千分位"}},[_c('el-checkbox',{model:{value:(_vm.component.properties.bit),callback:function ($$v) {_vm.$set(_vm.component.properties, "bit", $$v)},expression:"component.properties.bit"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-050404a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/componentAttr/thousand.vue
// module id = null
// module chunks = 